import { useCallback, useEffect, useState } from 'react';
import { PropagateLoader } from 'react-spinners';
import { GET_ENTERPRISE_BY_USER } from '../../../api/apiEmpresas';
import { linksAdmin, linksAdminNotSuper } from "../../../data/adminLinks";
import { linksAccountant } from "../../../data/accountantLinks";
import { linksLawyer } from "../../../data/lawyerLinks";
import Link from '../../atoms/LayoutAtoms/Link';
import { MdDashboard } from "react-icons/md";
import { useSession } from '../../../context/SessionContext';
import { FaUser } from "react-icons/fa";
import useModal from '../../../hooks/useModal';
import ModalConfirm from '../ModalConfirm';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { IoExitOutline } from "react-icons/io5";
import { GrAnnounce } from 'react-icons/gr';
import { linksRH } from '../../../data/rhLinks';

const MenuLinks = ({ onClose }) =>  {
    const { user, setUser } = useSession();
    const navigate = useNavigate();
    const [empresas, setEmpresas] = useState();
    const { open: openOut, close: closeOut, isOpen: isOpenOut } = useModal();

    const handleSingOut = async () => {
        try {
            localStorage.removeItem("token");
            setUser(null);
            toast.success("Sesión cerrada exitosamente");
            navigate("/");
        } catch (error) {
            console.error(error);
            toast.error("Error al cerrar sesión");
        }
    };

    const getEnterprises = useCallback(async () => {
        try {
            const enterprisesData = await GET_ENTERPRISE_BY_USER(user?.id);
            setEmpresas(enterprisesData);
        } catch (error) {
            console.error(error);
        }
    }, [user?.id]);
    
    useEffect(() => {
        if (!!user && user?.id && user?.role === "Client") {
            getEnterprises();
        }
    }, [user ,user?.id, user?.role, getEnterprises]);    
    
    let links;

    if (user?.role === "Admin" && user?.roleInfo?.isSuperAdmin === true) {
        links = linksAdmin;
    } else if (user?.role === "Admin" && user?.roleInfo?.isSuperAdmin === false) {
        links = linksAdminNotSuper;
    } else if (user?.role === "Lawyer") {
        links = linksLawyer;
    } else if (user?.role === "Accountant") {
        links = linksAccountant;
    } else if (user?.role === "HumanResources") {
        links = linksRH;
    } else if (user?.role === "Client") {
        const newEmpresas = empresas?.map((empresa) => ({ path: `/clientes/empresas/${empresa?.id}/decide`, label: `${empresa?.name}` }));
        links = newEmpresas;
    };

    return (
        <div className=''>
            <Link href={"/perfil"} label={user?.roleInfo?.name} onClose={onClose} Icon={FaUser}/>
            <Link href={"/dashboard"} label="Dashboard" onClose={onClose} Icon={MdDashboard}/>
            {!links ? 
                    <div className='w-full h-12 flex justify-center items-center'>
                        <PropagateLoader color='red' />
                    </div>
                : 
                <div>
                    {links?.map((link, index) =>
                        <Link href={link.path} label={link.label} onClose={onClose} key={index} Icon={link.icon} />
                    )}
                    <Link href="/avisosyblog" label="Avisos y Blog" onClose={onClose} Icon={GrAnnounce} />
                </div>
            }
            <button onClick={openOut} className='w-[92%] text-sm flex flex-row p-2 justify-between bg-rs-azul text-white ml-2 rounded-lg hover:bg-black'> Cerrar sesión <IoExitOutline size={20}/></button>
            {isOpenOut &&
                <ModalConfirm onClose={closeOut} onConfirm={handleSingOut} />
            }
        </div>
    )
};

export default MenuLinks;